module.exports = __webpack_public_path__ + "img/image.ef998a9e.svg";